import { frontendURL } from '../../../helper/URLHelper';
import VisitasIndex from '../visitas/pages/VisitasIndex.vue';

export const timeBlockRoute = {
  path: frontendURL('accounts/:accountId/bloqueio-de-horarios'),
  component: VisitasIndex,
  meta: {
    referenceAuthenticated: true,
  },
};

export default timeBlockRoute;
